import { Batch, EnvironmentCountries, TemplateType } from '@e-origin/shared';

interface UtbEligibilitySettings {
  enableUtbReport?: boolean;
  isForwarder?: boolean;
  country?: string;
}

export const canShowUTBReportBE = (batch: Batch): boolean =>
  batch.statistics.accepted > 0 ||
  batch.statistics.released > 0 ||
  batch.statistics.inControl > 0 ||
  batch.statistics.invalidated > 0 ||
  batch.statistics.notReleased > 0;

export const isUtbReportAvailable = (batch: Batch, settings: UtbEligibilitySettings): boolean => {
  if (batch.templateType !== TemplateType.HIGH_VALUE_H1 || !settings.enableUtbReport || settings.isForwarder) {
    return false;
  }

  return settings.country === EnvironmentCountries.NL || canShowUTBReportBE(batch);
};
